/**
 * @generated SignedSource<<3b6cc8311e9877a0888e1aa1cca38e5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation$variables = {
  id: string;
  priority: TodoPriority;
};
export type WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation$data = {
  readonly todoWorkspace: {
    readonly updatePriority: {
      readonly id: string;
      readonly priority: TodoPriority;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo">;
    };
  };
};
export type WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation$rawResponse = {
  readonly todoWorkspace: {
    readonly updatePriority: {
      readonly id: string;
      readonly priority: TodoPriority;
      readonly updatedAtDate: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation = {
  rawResponse: WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation$rawResponse;
  response: WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation$data;
  variables: WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "priority"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "newPriority",
    "variableName": "priority"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updatePriority",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainEditedInfo_Todo"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updatePriority",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ebb2c2d804309cde6d4f38619a72f9b",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation(\n  $id: ID!\n  $priority: TodoPriority!\n) {\n  todoWorkspace(id: $id) {\n    updatePriority(newPriority: $priority) {\n      id\n      priority\n      ...WorkspaceTodoEditMainEditedInfo_Todo\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "8a8a79863a3f2904f19f721d62d6c9bd";

export default node;
